import { Container, FormGroup, Form } from 'components/ui';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import i18n from '../../../../i18n'; // eslint-disable-line
import { useSelector } from 'react-redux';
import useFormUpdate from 'components/impfschaeden/assistent/hooks/useFormUpdate.js';
import { VaxFormTitle } from 'components/impfschaeden/assistent/components/VaxFormTitle.js';
import { Vorerkrankungen } from 'VaxForm_07_Vorerkrankungen/components/Vorerkrankungen.js';
import useTranslatedValidation from 'components/impfschaeden/assistent/hooks/useTranslatedValidation.js';

const FormStyle = styled(Form)`
	width: '100%';
	align-items: 'center';
`;

const Step07 = (props) => {
	const [t] = useTranslation(['translation']);
	const vaxFormData = useSelector((state) => state.vaxFormData);
	const { update } = useFormUpdate('vaxStep7');
	const validation = useTranslatedValidation('vaxStep7');

	return (
		<>
			<form
				className={FormStyle}
				onSubmit={(e) => {
					e.preventDefault();
					if (props.next) {
						props.next();
					}
				}}
			>
				<Container spacing={4}>
					<VaxFormTitle
						title={
							vaxFormData.anotherPerson
								? t('impfschaeden.erfassen.geimpfter_gesund')
								: t('impfschaeden.erfassen.vor_impfung_gesund')
						}
						edit={props.edit}
					/>
					<FormGroup className='mb-3' style={{ marginTop: '10px' }}>
						<Vorerkrankungen
							anotherPerson={vaxFormData?.anotherPerson}
							formData={vaxFormData}
							validation={validation}
							update={update}
						/>
					</FormGroup>
				</Container>
			</form>
		</>
	);
};

Step07.propTypes = {
	anotherPerson: PropTypes.bool,
	next: PropTypes.func,
	validation: PropTypes.object,
	globHealthDamages: PropTypes.array,
	vaxFormData: PropTypes.object,
	loadGlobMasterData: PropTypes.func,
	updateFormData: PropTypes.func,
	edit: PropTypes.bool,
};

export default Step07;
